import styled from "@emotion/styled";
import { ReactComponent as DownIcon } from "../../../img/Down.svg";

interface AccordionDownIconProps {
  isAccordionOpen: boolean;
}

export const AccordionDownIcon = styled(DownIcon, {
  shouldForwardProp: propName => propName !== "isAccordionOpen",
})<AccordionDownIconProps>`
  transform: ${props => (props.isAccordionOpen ? "rotate(-180deg)" : "none")};
  transition: transform 0.1s;
  stroke: white;
  path {
    stroke-width: 2px;
  }
`;
